import { ComponentProps } from 'react';
import { H3, IconLockup, PortableText, TypeWrapper } from '@ahmdigital/ui';

import { PortableTextType } from '../../../../../../../types/sanityInternal';
import styles from './styles.module.sass';

type InclusionsItemProps = {
  description?: PortableTextType[];
  icon?: ComponentProps<typeof IconLockup>['icon']['name'];
  itemTitle?: string | null;
};

const InclusionsItem = ({ description, icon = 'tick-circle', itemTitle }: InclusionsItemProps) => (
  <TypeWrapper variant={[styles.inclusion, 'paddingBottomSpacer10', 'paddingTopSpacer10']}>
    <IconLockup icon={{ className: styles.icon, name: icon, size: 'small', type: 'included' }}>
      {itemTitle && <H3 looksLike="h4">{itemTitle}</H3>}
      {description && <PortableText source={description} />}
    </IconLockup>
  </TypeWrapper>
);

export default InclusionsItem;
